import { PlusIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export function LogoCloud({ className, ...props }) {
  return (
    <div
      className={cn(
        "relative grid grid-cols-2 border-[#01193D]/10 md:grid-cols-4 border-x",
        className
      )}
      {...props}
    >
      <div className="-translate-x-1/2 -top-px pointer-events-none absolute left-1/2 w-screen border-t border-[#01193D]/10" />

      <LogoCard
        className="relative border-r border-b border-[#01193D]/10 bg-[#CAF2F9]/10"
        logo={{
          src: "https://svgl.app/library/nvidia-wordmark-light.svg",
          alt: "Nvidia Logo",
        }}
      >
        <PlusIcon
          className="-right-[12.5px] -bottom-[12.5px] absolute z-10 size-6 text-[#2563EB]/40 bg-white"
          strokeWidth={1}
        />
      </LogoCard>

      <LogoCard
        className="border-b md:border-r border-[#01193D]/10 bg-white/40"
        logo={{
          src: "https://svgl.app/library/supabase_wordmark_light.svg",
          alt: "Supabase Logo",
        }}
      />

      <LogoCard
        className="relative border-r border-b border-[#01193D]/10 bg-[#CAF2F9]/15"
        logo={{
          src: "https://svgl.app/library/github_wordmark_light.svg",
          alt: "GitHub Logo",
        }}
      >
        <PlusIcon
          className="-right-[12.5px] -bottom-[12.5px] absolute z-10 size-6 text-[#2563EB]/40 bg-white"
          strokeWidth={1}
        />
        <PlusIcon
          className="-bottom-[12.5px] -left-[12.5px] absolute z-10 hidden size-6 md:block text-[#2563EB]/40 bg-white"
          strokeWidth={1}
        />
      </LogoCard>

      <LogoCard
        className="relative border-b border-[#01193D]/10 bg-white/40"
        logo={{
          src: "https://svgl.app/library/openai_wordmark_light.svg",
          alt: "OpenAI Logo",
        }}
      />

      <LogoCard
        className="relative border-r border-b border-[#01193D]/10 bg-[#CAF2F9]/10 md:bg-white/40"
        logo={{
          src: "https://svgl.app/library/turso-wordmark-light.svg",
          alt: "Turso Logo",
        }}
      >
        <PlusIcon
          className="-right-[12.5px] -bottom-[12.5px] md:-left-[12.5px] absolute z-10 size-6 md:hidden text-[#2563EB]/40 bg-white"
          strokeWidth={1}
        />
      </LogoCard>

      <LogoCard
        className="border-b border-[#01193D]/10 bg-white/40 md:border-r md:border-b-0 md:bg-[#CAF2F9]/10"
        logo={{
          src: "https://svgl.app/library/clerk-wordmark-light.svg",
          alt: "Clerk Logo",
        }}
      />

      <LogoCard
        className="border-r border-[#01193D]/10 bg-white/40"
        logo={{
          src: "https://svgl.app/library/claude-ai-wordmark-icon_light.svg",
          alt: "Claude AI Logo",
        }}
      />

      <LogoCard
        className="bg-[#CAF2F9]/15 border-b border-[#01193D]/10 md:border-b-0"
        logo={{
          src: "https://svgl.app/library/vercel_wordmark.svg",
          alt: "Vercel Logo",
        }}
      />

      <div className="-translate-x-1/2 -bottom-px pointer-events-none absolute left-1/2 w-screen border-b border-[#01193D]/10" />
    </div>
  );
}

function LogoCard({ logo, className, children, ...props }) {
  return (
    <div
      className={cn(
        "flex items-center justify-center bg-transparent px-4 py-10 md:p-10",
        className
      )}
      {...props}
    >
      <img
        alt={logo.alt}
        className="pointer-events-none h-4 select-none md:h-5 opacity-40 hover:opacity-80 transition-opacity duration-300"
        height={logo.height || "auto"}
        src={logo.src}
        width={logo.width || "auto"}
      />
      {children}
    </div>
  );
}
